// @ts-nocheck
import { name2num, num2name, } from "../../../inside/Country";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as Long, } from "../../../../runtime/Long";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        id: "0",
        country: "UNSPECIFIED_COUNTRY",
        authorityConfigSetId: "0",
        days: "0",
        authorityConfigSetIdForExisting: "0",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.id !== undefined)
        result.id = tsValueToJsonValueFns.int64(value.id);
    if (value.country !== undefined)
        result.country = tsValueToJsonValueFns.enum(value.country);
    if (value.authorityConfigSetId !== undefined)
        result.authorityConfigSetId = tsValueToJsonValueFns.int64(value.authorityConfigSetId);
    if (value.days !== undefined)
        result.days = tsValueToJsonValueFns.int64(value.days);
    if (value.authorityConfigSetIdForExisting !== undefined)
        result.authorityConfigSetIdForExisting = tsValueToJsonValueFns.int64(value.authorityConfigSetIdForExisting);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.id !== undefined)
        result.id = jsonValueToTsValueFns.int64(value.id);
    if (value.country !== undefined)
        result.country = jsonValueToTsValueFns.enum(value.country);
    if (value.authorityConfigSetId !== undefined)
        result.authorityConfigSetId = jsonValueToTsValueFns.int64(value.authorityConfigSetId);
    if (value.days !== undefined)
        result.days = jsonValueToTsValueFns.int64(value.days);
    if (value.authorityConfigSetIdForExisting !== undefined)
        result.authorityConfigSetIdForExisting = jsonValueToTsValueFns.int64(value.authorityConfigSetIdForExisting);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.id !== undefined) {
        const tsValue = value.id;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.country !== undefined) {
        const tsValue = value.country;
        result.push([2, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.authorityConfigSetId !== undefined) {
        const tsValue = value.authorityConfigSetId;
        result.push([3, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.days !== undefined) {
        const tsValue = value.days;
        result.push([4, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.authorityConfigSetIdForExisting !== undefined) {
        const tsValue = value.authorityConfigSetIdForExisting;
        result.push([5, tsValueToWireValueFns.int64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.id = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.country = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.authorityConfigSetId = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.days = value;
    }
    field: {
        const wireValue = wireFields.get(5);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.authorityConfigSetIdForExisting = value;
    }
    return result;
}
